import { createCollectionStatusReducer, createCollectionReducer } from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';
import Recommendation from '../interfaces/recommendation';

type RecommnendationRecord = {
  id: number;
  recommendations: Recommendation[];
};

const list = createCollectionReducer<RecommnendationRecord>(
  ActionTypes.FETCH_RECOMMENDATIONS_SUCCESS
);
const status = createCollectionStatusReducer(
  ActionTypes.FETCH_RECOMMENDATIONS_REQUEST,
  ActionTypes.FETCH_RECOMMENDATIONS_NOT_FOUND,
  ActionTypes.FETCH_RECOMMENDATIONS_ERROR,
  ActionTypes.FETCH_RECOMMENDATIONS_SUCCESS
);

export default combineReducers({
  list,
  status
});
